export default __webpack_public_path__ + "static/media/Tswift.4b851be6.jpg";